const FaroeIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111423)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.1303 20.0001L39.8302 17.3914C39.714 16.5023 39.5396 15.6313 39.3109 14.7827H18.2607V0.0761719C17.3732 0.152578 16.5025 0.287656 15.652 0.47625L12.1737 2.60875L10.4346 2.4332C9.51935 2.93258 8.6474 3.50133 7.82592 4.1325V14.7827H0.688809C0.460137 15.6313 0.285762 16.5022 0.169512 17.3913L0.869355 20.0001L0.169434 22.6088C0.285684 23.4979 0.460059 24.3688 0.68873 25.2174H7.82584V35.8676C8.64732 36.4988 9.51935 37.0675 10.4345 37.5669L13.0432 37.3913L15.6519 39.5238C16.5024 39.7123 17.3731 39.8474 18.2605 39.9239V25.2175H39.3107C39.5394 24.3689 39.7137 23.498 39.83 22.6088L39.1303 20.0001Z"
        fill="#0052B4"
      />
      <path
        d="M39.8307 17.3915H15.6523H15.6522V0.475586C13.8039 0.88543 12.0516 1.54973 10.4348 2.43199V17.3914H0.169297C0.058125 18.2454 0 19.1161 0 20.0002C0 20.8843 0.058125 21.755 0.169297 22.6089H10.4347H10.4348V37.5683C12.0516 38.4505 13.8039 39.115 15.6522 39.5247V22.6091V22.6089H39.8307C39.9419 21.755 40 20.8843 40 20.0002C40 19.1161 39.9419 18.2454 39.8307 17.3915Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111423">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default FaroeIslandsSvg;
